import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, resolveApiUrl } from "./api";

const EMPTY_BRANDING = {
  light_logo_url: null,
  dark_logo_url: null,
};

const SystemBrandingContext = createContext({
  branding: EMPTY_BRANDING,
  reloadBranding: async () => {},
});

function normalizeBranding(payload) {
  return {
    light_logo_url: payload?.light_logo_url ? resolveApiUrl(payload.light_logo_url) : null,
    dark_logo_url: payload?.dark_logo_url ? resolveApiUrl(payload.dark_logo_url) : null,
  };
}

export function SystemBrandingProvider({ children }) {
  const [branding, setBranding] = useState(EMPTY_BRANDING);

  const reloadBranding = useCallback(async () => {
    try {
      const response = await api.get("/api/system-branding");
      setBranding(normalizeBranding(response.data));
    } catch {
      setBranding(EMPTY_BRANDING);
    }
  }, []);

  useEffect(() => {
    reloadBranding();
  }, [reloadBranding]);

  const value = useMemo(
    () => ({
      branding,
      reloadBranding,
    }),
    [branding, reloadBranding]
  );

  return <SystemBrandingContext.Provider value={value}>{children}</SystemBrandingContext.Provider>;
}

export function useSystemBranding() {
  return useContext(SystemBrandingContext);
}
